import './index.scss';

import Paper from '@material-ui/core/Paper';
import React from 'react';

export default class Box extends React.Component {

    render() {
        return (
            <div className={'container-box '}>
                <Paper className={'paper'}>
                    {this.props.children}
                </Paper>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/basic/box/index.js